import React from "react";
import { Box } from "@mui/material";
import TitleBar from "../navbar/TitleBar";
import NavMenu from "../navbar/NavMenu";
import Footer from "../common/Footer";
import Alerts from "./Alerts";

const Alert = () => {
  return (
    <>
      <TitleBar />
      <NavMenu />
      <Box
        sx={{
          backgroundColor: "#f5f7f9",
          minHeight: "100vh",
          minWidth: "90vw",
          marginBottom: "8vh",
        }}
      >
        <Alerts />
      </Box>
      <Footer />
    </>
  );
};

export default Alert;
